import type { ReactNode } from "react"

import type { ManagePositionHeaderViewProps } from "./manage-position-header-view"
import type { ManagePositionTabId } from "./manage-position-tabs-view"
import { ManagePositionHeaderView } from "./manage-position-header-view"
import { ManagePositionTabsView, MANAGE_POSITION_TABS } from "./manage-position-tabs-view"

/**
 * Shell view for any manage-position screen.
 *
 * Renders the header, the tab row, and whatever tab content the caller
 * supplies. Composites choose which tab is "active" based on the current
 * route segment (settings, collect, close, increase, decrease) and delegate
 * tab navigation to the caller — so the view itself stays pure.
 */
export const ManagePositionLayoutView = ({
  header,
  activeTab,
  onTabChange,
  trailingActions,
  overview,
  increase,
  decrease,
  collect,
  close,
  history,
}: {
  header: ManagePositionHeaderViewProps
  activeTab: ManagePositionTabId
  onTabChange: (tab: ManagePositionTabId) => void
  trailingActions?: ReactNode
  overview?: ReactNode
  increase?: ReactNode
  decrease?: ReactNode
  collect?: ReactNode
  close?: ReactNode
  history?: ReactNode
}) => {
  return (
    <div className="flex flex-col gap-6">
      <ManagePositionHeaderView {...header} trailingActions={trailingActions} />
      <ManagePositionTabsView
        activeTab={activeTab}
        onTabChange={onTabChange}
        tabs={MANAGE_POSITION_TABS}
        overview={overview}
        increase={increase}
        decrease={decrease}
        collect={collect}
        close={close}
        history={history}
      />
    </div>
  )
}
